import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import {Dropdown, Icon, Menu} from 'semantic-ui-react'
import { withCookies } from "react-cookie";
import TroveLogo from "../Trove";

class SiteHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Menu id="masthead" borderless>
                <Menu.Item
                    as={Link}
                    to='/'
                    title='Home'
                    className='troveLogoMenuItem'
                    content={<TroveLogo />}
                />
                <Menu.Menu position='right'>
                    <Menu.Item icon='map marker alternate' content='Play' active={(window.location.pathname === '/browse')} as={Link} to='/browse' />
                    <Menu.Item icon='pencil' content='Create' as={Link} to='/create' />
                { (this.props.cookies.cookies.user ?
                        <Dropdown
                            item
                            className={(window.location.pathname === '/user' ? 'active' : '')}
                            trigger={<><Icon name='user' /> <span className='computerOnly'>{ JSON.parse(this.props.cookies.cookies.user).user_display_name }</span></>}
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    icon='user'
                                    content='My Account'
                                    as={Link}
                                    to='/user' />
                                <Dropdown.Item
                                    onClick={this.props.doLogout}
                                    content='Logout'
                                    icon='log out'
                                />
                            </Dropdown.Menu>
                        </Dropdown> :
                        <Menu.Item
                            icon='user'
                            content='Login'
                            as={Link}
                            to='/user' />
                ) }
                </Menu.Menu>
            </Menu>
        )
    }
}
export default withRouter(withCookies(SiteHeader))